import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DuplicateSavedViewMutation,
  DuplicateSavedViewMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { createSavedViewCreatedEvent } from "lib/savedViewTracking";
import { EventDataTypes, EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../../useGraphQlClient";

const duplicateSavedView = graphql(`
  mutation DuplicateSavedView($request: DuplicateSavedViewRequest!) {
    duplicateSavedView(DuplicateSavedViewRequest: $request) {
      id
      name
      description
      dataType
    }
  }
`);

export function useDuplicateSavedView(
  options?: UseMutationOptions<
    DuplicateSavedViewMutation,
    unknown,
    DuplicateSavedViewMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { logEvent } = useTracking();

  const { data, ...rest } = useGraphQlMutation(duplicateSavedView, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: ["savedViews"] });
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptionContents"] });
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptions"] });
      options?.onSuccess && options?.onSuccess(data, variables, context);

      logEvent(
        EventNames.viewCreated,
        createSavedViewCreatedEvent(
          variables.request.name,
          EventDataTypes.documents,
          variables.request.alertFrequency || "NEVER",
          variables.request.id,
        ),
      );
    },
  });

  return { data: data?.duplicateSavedView, ...rest };
}
